// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {2242: "b37169e4205f77a1",3368: "2b6f79c5df89c71a",5001: "7ff674ee62d68fb7",8737: "cdd296530d066847",}[chunkId] + ".css"
}